import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-maintenance',
  imports: [],
  templateUrl: './maintenance.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './maintenance.component.scss',
})
export class MaintenanceComponent implements OnInit {
  ngOnInit(): void {}
}
